import React from 'react';
import FishDisease from "../../_components/FishDisease";
import LiceList from "../../../../components/Operation/LiceList";
import AttachFile from "../../../../components/Popup/PopupOpInfo/_component/AttachFile";
import Tasks from "../../../../components/Popup/PopupOpInfo/Info/Treatment/Tasks";
import { InfoMode, OPERATION_TYPE } from "../../../../util/varibles/constants";
import { convertActivityLog, durationTxtByStartAndFinish } from "../../../../util/varibles/global";
import { IOperation2, ITreatment2 } from "../../../../util/varibles/interface";
import { RoundMapProvider } from "../../../PlanOperationPage/Popup/EditOp/EditOperationContext/RoundMapContext";
import Round from "../../../PlanOperationPage/Popup/EditOp/Treatment/RoundMap/Round";
import Tank from "../../../PlanOperationPage/Popup/EditOp/Treatment/RoundMap/Tank";
import stylesOp from "../../_components/Operation/style.module.scss";
import Analytics from "../../_components/Analytics";
import Checklists from "../../_components/Checklists";
import Operation from "../../_components/Operation";
import OperationTime from "../../_components/OperationTime";
import Route from "../../_components/Route";
import Vessel from "../../_components/Vessel";
import ViewNote from "../../_components/ViewNote";
import WrapperActivityLog from "../../_components/WrapperActivityLog";
import stylesContainer from "../../style.module.scss";

interface IProps {
    data: IOperation2<ITreatment2>
    isOwn: boolean
}

const Treatment: React.FC<IProps> = ({ data, isOwn }) => {
    const { note = '', files = [], sub_operations, round_map = {} } = data.operation;
    const isNote = note.length === 0;

    const { activity_log } = data;
    const est_start_time = activity_log[0].est_start_time;
    const est_finish_time = activity_log[activity_log.length - 1].est_start_time;
    const activityLog = convertActivityLog[OPERATION_TYPE.TREATMENT](activity_log);

    return <div className='col-span-2 pb-3'>
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Operation {...{ isNote }}>
                <OperationTime activity_log={activity_log} />
                <OperationTime activity_log={activity_log} mode={InfoMode.ACTUAL} />
                <div className={stylesOp['info-line']}>
                    <span>Planned duration: </span>
                    <span>{durationTxtByStartAndFinish(est_start_time, est_finish_time)}</span>
                </div>
                <div className={stylesOp['info-line']}>
                    <AttachFile files={files} />
                </div>
                <FishDisease diseases={data.operation.diseases || []} units={sub_operations} wrapperClass='mb-[5px]' />
                <LiceList diseases={data.operation.diseases || []} />
                <div className='mt-3'>
                    <Tasks data={data.operation as ITreatment2} />
                </div>
                <ViewNote data={data} isOwn={isOwn} note={note} />
                    </Operation>
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Checklists />
                </div>
            </div>
            <Analytics data={data} />
            <div className='grid grid-cols-1 items-stretch gap-[15px] min-[901px]:grid-cols-[minmax(0,2fr)_minmax(290px,1fr)] mb-[15px]'>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <Vessel />
                </div>
                <div className='min-w-0 [&>div]:!mb-0 [&>div]:!h-full [&>div]:w-full'>
                    <WrapperActivityLog
                        isOwn={isOwn}
                        data={data}
                        activity_log={activityLog}
                        activity_log_root={activity_log}
                    />
                </div>
            </div>
            <Route />
            <div className={stylesContainer.section}>
                <div className={stylesContainer['header-box']}>
                    <div className="flex justify-content-between align-items-center">
                        <div className="flex align-items-center">
                            <span className="mr-3 mb-2">Activity log</span>
                        </div>
                    </div>
                </div>
                <RoundMapProvider>
                    {Object.keys(round_map).map((key, i, arr) => {
                        const { after_processes, tanks } = round_map[key];
                        const nextRound = arr[i + 1];

                        return <Round
                            key={key}
                            roundId={key}
                            after_processes={after_processes}
                        >
                            <div className='grid gap-3 z-[1]'
                                style={{ gridTemplateColumns: `repeat(${tanks.length}, 1fr)` }}>
                                {tanks.map((item, i: number) => <Tank
                                    key={i}
                                    data={item}
                                    nextUnit={!!round_map[nextRound]}
                                />)}
                            </div>
                        </Round>
                    })}
                </RoundMapProvider>
            </div>
    </div>;
};

export default Treatment;
